import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import MuiInput from '@mui/material/Input';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import { useEffect, useState, useMemo } from 'react';
import debounce from 'lodash/debounce';

const Input = styled(MuiInput)`
    width: 42px;
`;

interface TextSliderProps {
    Label: string;
    DefaultValue: number | null; // Change type to number or null
    ID: string;
    Minimum: number;
    Maximum: number;
    Step: number;
    onChange?: (value: number | null) => void; // Change type to number or null
}

const TextSlider = ({ Label, DefaultValue, ID, Minimum, Maximum, Step, onChange }: TextSliderProps) => {
    const [value, setValue] = useState<number | null>(DefaultValue); // Set initial state to DefaultValue

    // Renders only when "value" changes
    useEffect(() => {
        // If onChange exists
        if (onChange) {
            // Then change the value
            onChange(value);
        }
    }, [value]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value === '' ? null : Number(event.target.value)); // Handle null input
    };

    // Implemnt a 70 millisecond deplay
    const debouncedHandleSliderChange = useMemo(
        () =>
            debounce((event: Event, newValue: number | number[]) => {
                setValue(newValue as number);
            }, 70),
        []
    );

    const handleBlur = () => {
        if (value !== null) {
            if (value < Minimum) {
                setValue(Minimum);
            } else if (value > Maximum) {
                setValue(Maximum);
            }
        }
    };

    return (
        <Box>
            <Typography id={ID} gutterBottom>
                {Label}
            </Typography>
            <Grid container spacing={2} alignItems="center">
                <Grid item xs>
                    <Slider value={typeof value === 'number' ? value : 0} onChange={debouncedHandleSliderChange} aria-labelledby={ID} step={Step} min={Minimum} max={Maximum} />
                </Grid>
                <Grid item>
                    <Input
                        value={value}
                        size="small"
                        onChange={handleInputChange}
                        onBlur={handleBlur}
                        inputProps={{
                            step: Step,
                            min: Minimum,
                            max: Maximum,
                            type: 'number',
                            'aria-labelledby': ID
                        }}
                        style={{ width: 90 }}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default TextSlider;
